import { IndexedObjects, IndexedObjectsByString } from "@/core/types/storeTypes";
import { AnyContentTypeWithFull } from "@/core/types/contentTypes";
import getFullContent from "@/core/dataProviders/utils/getFullContent";

/**
 * returns single content from provided data
 *
 * @TODO consider if possible to rework to hooks similar to ./hooks/contentFilters
 * */

function getContent<T extends AnyContentTypeWithFull>(
  slug: string | null,
  content: IndexedObjects<T> | undefined,
  slugToContentId: IndexedObjectsByString<number> | undefined,
  isSimple: boolean
): T | null {
  // null if invalid input data
  if (!slug || !content || !slugToContentId) {
    return null;
  }
  // hotfix for slugs that contain invalid symbols like '.'
  // @TODO check if still needed, should not be anymore since API should no longer return invalid slugs
  const regEx = /[^a-zA-Z0-9 ]/g;
  const simpleSlug = slug.replace(regEx, "");

  // search for ID in all IDs
  const contentID = Object.keys(slugToContentId).find((key) => key.replace(regEx, "") === simpleSlug);
  if (!contentID) {
    return null;
  }
  // if the data is full content, continue on `getFullContent`
  if (!isSimple) {
    return getFullContent(contentID, content, slugToContentId);
  }
  return content[slugToContentId[contentID]] ? content[slugToContentId[contentID]] : null;
}

export default getContent;
